import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HeaderService } from './layout/services/header.service';
import { SidebarService } from './layout/services/sidebar.service';
import { PosthogService } from './data/services/posthog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  showHeader = false;
  showSidebar = false;
  showFooter = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private headerService: HeaderService,
    private sidebarService: SidebarService,
    private posthogService: PosthogService
    ) {
      this.translate.addLangs(['es', 'en']);
      this.translate.setDefaultLang('es');
      this.translate.use('es');
    }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        
        const destination = this.activatedRoute.snapshot.firstChild?.data['destination'];
        if (this.router.url === '/' && destination) {
          this.router.navigateByUrl(destination);
        }

        const queryParams = this.activatedRoute.snapshot.queryParamMap;
        const isMoodle = queryParams.has('moodle');

        this.showHeader = isMoodle ? false : this.getLastChildData(this.activatedRoute)['showHeader'];
        this.showSidebar = isMoodle ? false : this.getLastChildData(this.activatedRoute)['showSidebar'];
        // this.showFooter = this.getLastChildData(this.activatedRoute)['showFooter'];
      }
    });

    this.headerService.showHeader$.subscribe(value => {
      this.showHeader = value;
    });

    this.sidebarService.showSidebar$.subscribe(value => {
      this.showSidebar = value;
    });
  }

  getLastChildData(route: ActivatedRoute): any {
    if (route.firstChild?.snapshot.data['showSidebar'] != null) return this.getLastChildData(route.firstChild);
    return route.snapshot.data;
  }


}
